import type { OptionSelect } from '@svoi-ui/interfaces/select'
import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import type { FiltersOptionModel } from '~/models/filters'

type SelectOption = FiltersOptionModel & OptionSelect

export default class FiltersItem extends BaseModel {
  static override constructorName = 'FiltersItem'

  options: SelectOption[] = []
  type: 'multiselect' | 'search' | 'date' = 'multiselect'
  values: unknown | null = null
  value: string = ''
  title: string = ''
  placeholder?: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (this.type === 'date' && Array.isArray(this.values) && this.values.length === 0) {
        this.values = null
      }
    }
  }
}

registerModel(FiltersItem)
